import { Phone, Mail, ExternalLink, MapPin } from "lucide-react";
import { COMPANY } from "@/lib/content";

export default function Footer() {
  return (
    <footer id="kapcsolat" data-testid="footer-section" className="relative bg-white border-t border-gray-200">
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-20">
        <div className="grid lg:grid-cols-12 gap-12">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 grid place-items-center rounded-sm bg-gradient-to-br from-blue-600 to-violet-600 glow-blue">
                <span className="font-display font-bold text-white">PT</span>
              </div>
              <div>
                <div className="font-display text-xl font-bold tracking-tight">PITSTOP TIRE KFT</div>
                <div className="text-[11px] uppercase tracking-[0.2em] text-violet-600/80">{COMPANY.slogan}</div>
              </div>
            </div>
            <p className="text-gray-400 text-sm leading-relaxed max-w-md">
              Budapest 24/7-es mobil gumiszervíze. Defektjavítás, helyszíni gumicsere, szezonális átszerelés, flotta szerződések és gumiértékesítés egy helyen.
            </p>

            <div className="mt-8 inline-flex items-center gap-3 px-4 py-2 rounded-full border border-green-500/30 bg-green-500/5">
              <span className="relative flex h-2 w-2">
                <span className="absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75 animate-ping"></span>
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-400"></span>
              </span>
              <span className="text-xs uppercase tracking-[0.2em] text-green-600 font-semibold">Most is dolgozunk</span>
            </div>
          </div>

          <div className="lg:col-span-4">
            <div className="text-xs uppercase tracking-[0.3em] text-violet-600 font-bold mb-6">Kapcsolat</div>
            <div className="space-y-5">
              <a data-testid="footer-phone" href={`tel:${COMPANY.phoneRaw}`} className="group flex items-start gap-4">
                <div className="w-10 h-10 grid place-items-center rounded-sm border border-gray-200 bg-gray-50 group-hover:border-violet-400 group-hover:bg-violet-500/10 transition-all">
                  <Phone className="w-4 h-4 text-violet-600" />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-gray-400">Telefon · 24/7</div>
                  <div className="font-display text-lg font-bold text-gray-900 group-hover:text-violet-600 transition-colors">{COMPANY.phone}</div>
                </div>
              </a>
              <a data-testid="footer-email" href={`mailto:${COMPANY.email}`} className="group flex items-start gap-4">
                <div className="w-10 h-10 grid place-items-center rounded-sm border border-gray-200 bg-gray-50 group-hover:border-violet-400 group-hover:bg-violet-500/10 transition-all">
                  <Mail className="w-4 h-4 text-violet-600" />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-gray-400">E-mail</div>
                  <div className="font-display text-base font-bold text-gray-900 group-hover:text-violet-600 transition-colors break-all">{COMPANY.email}</div>
                </div>
              </a>
              <a data-testid="footer-webshop" href={COMPANY.webshop} target="_blank" rel="noopener noreferrer" className="group flex items-start gap-4">
                <div className="w-10 h-10 grid place-items-center rounded-sm border border-gray-200 bg-gray-50 group-hover:border-violet-400 group-hover:bg-violet-500/10 transition-all">
                  <ExternalLink className="w-4 h-4 text-violet-600" />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-gray-400">Webshop</div>
                  <div className="font-display text-base font-bold text-gray-900 group-hover:text-violet-600 transition-colors">{COMPANY.webshopLabel}</div>
                </div>
              </a>
              <div className="flex items-start gap-4">
                <div className="w-10 h-10 grid place-items-center rounded-sm border border-gray-200 bg-gray-50">
                  <MapPin className="w-4 h-4 text-violet-600" />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.2em] text-gray-400">Lefedettség</div>
                  <div className="font-display text-base font-bold text-gray-900">Budapest + agglomeráció</div>
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-3">
            <div className="text-xs uppercase tracking-[0.3em] text-violet-600 font-bold mb-6">Linkek</div>
            <ul className="space-y-3 text-sm">
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href="#szolgaltatasok">Szolgáltatások</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href="#arkalkulator">Árkalkulátor</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href="#folyamat">Folyamat</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href="#flotta">Flotta ajánlatkérés</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href="#kozossegi">Közösségi</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href={COMPANY.webshop} target="_blank" rel="noopener noreferrer">Webshop ↗</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href={COMPANY.tiktok} target="_blank" rel="noopener noreferrer">TikTok ↗</a></li>
              <li><a className="text-gray-500 hover:text-violet-600 transition-colors" href={COMPANY.facebook} target="_blank" rel="noopener noreferrer">Facebook ↗</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-gray-200 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
          <div className="text-xs text-gray-400">
            © {new Date().getFullYear()} {COMPANY.name}. Minden jog fenntartva.
          </div>
          <div className="flex items-center gap-3">
            <a
              data-testid="footer-tiktok"
              href={COMPANY.tiktok}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 grid place-items-center rounded-sm border border-gray-200 bg-gray-50 hover:border-violet-400 hover:bg-violet-500/10 hover:text-violet-600 text-gray-600 transition-all"
              aria-label="TikTok"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.8 20.1a6.34 6.34 0 0 0 10.86-4.43V9.01a8.16 8.16 0 0 0 4.77 1.52v-3.4a4.85 4.85 0 0 1-1.84-.44z"/></svg>
            </a>
            <a
              data-testid="footer-facebook"
              href={COMPANY.facebook}
              target="_blank"
              rel="noopener noreferrer"
              className="w-10 h-10 grid place-items-center rounded-sm border border-gray-200 bg-gray-50 hover:border-blue-400 hover:bg-blue-500/10 hover:text-blue-600 text-gray-600 transition-all"
              aria-label="Facebook"
            >
              <svg viewBox="0 0 24 24" className="w-4 h-4" fill="currentColor"><path d="M22 12.06C22 6.5 17.52 2 12 2S2 6.5 2 12.06c0 5 3.66 9.15 8.44 9.94v-7.03H7.9v-2.9h2.54V9.85c0-2.51 1.49-3.9 3.77-3.9 1.1 0 2.24.2 2.24.2v2.47h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.9h-2.34V22c4.78-.79 8.44-4.93 8.44-9.94z"/></svg>
            </a>
          </div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-gray-400 font-mono">
            Built for the road · Budapest
          </div>
        </div>
      </div>

      {/* Giant outline brand text */}
      <div className="overflow-hidden border-t border-gray-200">
        <div className="font-display text-[80px] sm:text-[140px] md:text-[200px] font-black uppercase tracking-tighter text-outline whitespace-nowrap leading-none py-4 text-center">
          PITSTOP · TIRE · KFT
        </div>
      </div>
    </footer>
  );
}
